import React from 'react'

const testimonials = [
  {
    quote: "Professionalità e buon gusto. Il nostro stand in fiera si è distinto grazie alla parete verde che hanno creato per noi. Assolutamente consigliati.",
    name: "Anna Rossi",
    role: "Event Manager, Tech Corp"
  },
  {
    quote: "Servizio rapido, efficiente e di grande impatto. Abbiamo noleggiato delle piante per un evento aziendale e l'atmosfera è cambiata completamente. Grazie!",
    name: "Luca Bianchi",
    role: "Marketing Director, Creative Agency"
  },
  {
    quote: "L'allestimento per il nostro shooting fotografico è stato perfetto. Le piante hanno dato quel tocco di eleganza che cercavamo per il set.",
    name: "Sofia Martini",
    role: "Fotografa Professionista"
  }
]

const Testimonials = () => {
  return (
    <section id="testimonials" className="py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-20">
          <h2 className="text-4xl font-serif font-bold text-brand-green mb-4">Dicono di Noi</h2>
          <p className="text-lg text-brand-text/70 max-w-2xl mx-auto">La soddisfazione dei nostri clienti è la nostra più grande ricompensa.</p>
        </div>
        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-brand-subtle-bg p-8 rounded-lg flex flex-col">
              <svg className="w-10 h-10 text-brand-green/20 mb-6" fill="currentColor" viewBox="0 0 32 32">
                <path d="M9.981 22.373c0 3.322-2.69 6.012-6.012 6.012s-6.012-2.69-6.012-6.012c0-3.322 2.69-6.012 6.012-6.012 0-2.222.9-4.242 2.374-5.616-1.152-1.282-1.848-2.978-1.848-4.838 0-3.962 3.208-7.17 7.17-7.17 3.962 0 7.17 3.208 7.17 7.17 0 2.298-1.078 4.35-2.822 5.688 1.43 1.22 2.31 3.018 2.31 4.988 0 .456-.048.9-.132 1.332-2.222-2.222-5.118-3.648-8.31-3.648zm20.019 0c0 3.322-2.69 6.012-6.012 6.012s-6.012-2.69-6.012-6.012c0-3.322 2.69-6.012 6.012-6.012 0-2.222.9-4.242 2.374-5.616-1.152-1.282-1.848-2.978-1.848-4.838 0-3.962 3.208-7.17 7.17-7.17 3.962 0 7.17 3.208 7.17 7.17 0 2.298-1.078 4.35-2.822 5.688 1.43 1.22 2.31 3.018 2.31 4.988 0 .456-.048.9-.132 1.332-2.222-2.222-5.118-3.648-8.31-3.648z"></path>
              </svg>
              <p className="text-brand-text/80 italic mb-6 flex-grow">"{testimonial.quote}"</p>
              <div>
                <p className="font-bold text-brand-green">{testimonial.name}</p>
                <p className="text-sm text-brand-light-green">{testimonial.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Testimonials